import { render, staticRenderFns } from "./EditRoleDialog.vue?vue&type=template&id=2b44a4ec&"
import script from "./EditRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./EditRoleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports